module.exports = "../../app/cells/pages/discipline/summary_cell.rb";